import { object, string } from 'yup'

const ownerSchema = object().shape({
  id: string().default(''),
  companyName: string().default(''),
  companyAddress: string().default(''),
  email: string().default(''),
  password: string().default(''),
})

export const addDriverFormSchema = object().shape({
  firstName: string().default(''),
  lastName: string().default(''),
  phone: string().default('').required('Phone number is a required field'),
  owner: ownerSchema,
})
